import Checkbox from '@mui/material/Checkbox';
import { formatDate } from 'utils/commonUtils';
import Typography from '@mui/material/Typography';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const spedStudentColumns = (
  selectedIds = [],
  handleToggleSelect,
  handleSelectAll,
  allRows = []
) => [
  {
    field: 'select',
    headerName: '',
    width: 60,
    sortable: false,
    disableColumnMenu: true,
    align: 'center',
    headerAlign: 'center',
    renderHeader: () => {
      const allSelected =
        allRows?.length > 0 && selectedIds?.length === allRows?.length;
      const partiallySelected =
        selectedIds?.length > 0 && selectedIds?.length < allRows?.length;

      return (
        <Checkbox
          checked={allSelected}
          indeterminate={partiallySelected}
          onChange={(e) => handleSelectAll(e?.target?.checked)}
        />
      );
    },
    renderCell: (params) => (
      <Checkbox
        checked={selectedIds.includes(params?.row?.id)}
        onChange={(e) =>
          handleToggleSelect(params?.row?.id, e?.target?.checked)
        }
      />
    ),
  },
  {
    headerName: 'Student ID',
    field: 'studentNumber',
    flex: 1,
  },
  {
    headerName: 'First Name',
    field: 'firstName',
    flex: 1,
    renderCell: (params) => {
      const studentName = params?.row?.firstName;
      return <Typography variant="base">{studentName}</Typography>;
    },
  },

  {
    headerName: 'Last Name',
    field: 'lastName',
    flex: 1,
    sortable: true,
    renderCell: (params) => {
      const studentName = params?.row?.lastName;
      return <Typography variant="base">{studentName}</Typography>;
    },
  },
  {
    headerName: 'Courses',
    field: 'courses',
    align: 'center',
    flex: 1,
    renderCell: renderCellExpand,
  },
  { headerName: 'Grade', field: 'gradeLevel', flex: 1 },
];

export const getSpedStudentProfileListData = (studentProfileListData) => {
  const items = studentProfileListData?.items;
  if (!items || items?.length === 0) {
    return [];
  }
  return items?.map(
    ({
      resourceId,
      version,
      lastName,
      firstName,
      studentNumber,
      gradeLevel,
      studentType,
      courses,
      stateId,
      homePrimaryLanguage,
      raceEthnicity,
      gender,
      dateOfBirth,
      isActive,
      lastActiveSemester,
      dateLastActive,
      hasIepPlan,
      iepTeacher,
      note,
      noteUpdatedAt,
      noteUpdatedBy,
      createdAt,
      updatedAt,
    }) => ({
      id: resourceId,
      resourceId,
      version,
      firstName,
      lastName,
      name: `${firstName} ${lastName}`,
      studentNumber,
      gradeLevel,
      studentType,
      stateId,
      courses: courses?.map((c) => c.courseName).join(', '),
      coursesData: courses,
      homePrimaryLanguage,
      raceEthnicity,
      gender,
      dateOfBirth: formatDate(dateOfBirth),
      isActive,
      lastActiveSemester: lastActiveSemester,
      dateLastActive: dateLastActive,
      hasIepPlan,
      iepTeacher,
      note,
      noteUpdatedAt: formatDate(noteUpdatedAt),
      noteUpdatedBy,
      createdAt: formatDate(createdAt),
      updatedAt: formatDate(updatedAt),
    })
  );
};
